import { defineStore } from 'pinia'

export const useResultsStore = defineStore({
    id: 'citation-search-results',
    state: () => ({
        Overview: {} as server.CitationSearchResultOverview,
        Assessments: [] as Array<server.CitationSearchResultAssessment>,
        Attachments: [] as Array<server.CitationSearchResultAttachment>,
    }),
    actions: {
        setResults(results: server.CitationSearchResult) {
            this.Overview = results.Overview;
            this.Assessments = results.Assessments.sort((a, b) => a.SortOrder - b.SortOrder);
            this.Attachments = results.Attachments;
        },

        clearResults() {
            this.Overview = {} as server.CitationSearchResultOverview;
            this.Assessments = [] as Array<server.CitationSearchResultAssessment>;
            this.Attachments = [] as Array<server.CitationSearchResultAttachment>;
        },

        setAmountUserWillPay(AmountToPay: number) {
            this.Overview.AmountToPay = AmountToPay;
        }
    },
    persist: true,
})
